import { render } from "./Screenshot.vue?vue&type=template&id=d845fbf6&scoped=true"
import script from "./Screenshot.vue?vue&type=script&lang=js"
export * from "./Screenshot.vue?vue&type=script&lang=js"

import "./Screenshot.vue?vue&type=style&index=0&id=d845fbf6&lang=less&scoped=true"

import exportComponent from "D:\\project\\famousBuild\\famous-build\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d845fbf6"]])

export default __exports__